import { env } from "@/env/client";
import { buildAuthClient } from "auth-itm/client";

export const authClient = buildAuthClient({
  baseURL: env.authUrl,
});
